module.exports = __webpack_public_path__ + "files/97d8a18f7a9b0a9580da3121aaef3756.png";